import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/home",
      name: "Home",
      component: () => import("@/views/home/Home.vue"),
      meta: {
        layout: "full",
      },
    },

    {
      path: "/flood_status",
      name: "FloodStatus",
      component: () => import("@/views/flood_status/FloodStatus.vue"),
      meta: {
        layout: "full",
      },
    },

    {
      path: "/login",
      name: "Login",
      component: () => import("@/views/auth/Login.vue"),
      meta: {
        layout: "full",
      },
    },

    {
      path: "/delete_profile",
      name: "DeleteProfile",
      component: () => import("@/views/auth/DeleteProfile.vue"),
      meta: {
        layout: "full",
      },
    },

    {
      path: "/privacy_policy",
      name: "PrivacyPolicy",
      component: () => import("@/views/privacy_policy/PrivacyPolicy.vue"),
      meta: {
        layout: "full",
      },
    },

    {
      path: "/forgotPassword",
      name: "ForgotPassword",
      component: () => import("@/views/auth/ForgotPassword.vue"),
      meta: {
        layout: "full",
      },
    },
    {
      path: "/verification",
      name: "VerificationCode",
      component: () => import("@/views/auth/VerificationCode.vue"),
      props: true,
      meta: {
        layout: "full",
      },
    },
    {
      path: "/newPassword",
      name: "NewPassword",
      component: () => import("@/views/auth/NewPassword.vue"),
      props: true,
      meta: {
        layout: "full",
      },
    },

    {
      path: "/changePassword",
      name: "ChangePassword",
      component: () => import("@/views/auth/ChangePassword.vue"),
      meta: {
        pageTitle: "Change Password",
        breadcrumb: [
          {
            text: "Change Password",
            active: true,
          },
        ],
        requiresAuth: true,
        permission: "update_user",
      },
    },

    {
      path: "/signup",
      name: "Signup",
      component: () => import("@/views/auth/Signup.vue"),
      meta: {
        layout: "full",
      },
    },
    {
      path: "/signupConfirmation",
      name: "SignupConfirmation",
      component: () => import("@/views/auth/SignupConfirmation.vue"),
      meta: {
        layout: "full",
      },
    },
    {
      path: "/user",
      name: "User",
      component: () => import("@/views/user/User.vue"),
      meta: {
        pageTitle: "User",
        breadcrumb: [
          {
            text: "User",
            active: true,
          },
        ],
        requiresAuth: true,
        permission: "show_user",
      },
    },
    {
      path: "/role",
      name: "Role",
      component: () => import("@/views/role/Role.vue"),
      meta: {
        pageTitle: "Role",
        breadcrumb: [
          {
            text: "Role",
            active: true,
          },
        ],
        requiresAuth: true,
        permission: "show_role",
      },
    },
    {
      path: "/portfolio",
      name: "Dashboard",
      component: () => import("@/views/dashboard/Dashboard.vue"),
      meta: {
        pageTitle: "Portfolio",
        breadcrumb: [
          {
            text: "Portfolio",
            active: true,
          },
        ],
        requiresAuth: true,
        permission: "show_dashboard",
      },
    },

    {
      path: "/site",
      name: "Site",
      component: () => import("@/views/site/Site.vue"),
      meta: {
        pageTitle: "Site",
        breadcrumb: [
          {
            text: "Site",
            active: true,
          },
        ],
        requiresAuth: true,
        permission: "show_site",
      },
    },

    {
      path: "/building",
      name: "Building",
      component: () => import("@/views/building/Building.vue"),
      meta: {
        pageTitle: "Building",
        breadcrumb: [
          {
            text: "Building",
            active: true,
          },
        ],
        requiresAuth: true,
        permission: "show_building",
      },
    },

    {
      path: "/qr_code",
      name: "QRCode",
      component: () => import("@/views/qr_code/QRCode.vue"),
      meta: {
        pageTitle: "QR Code",
        breadcrumb: [
          {
            text: "QR Code",
            active: true,
          },
        ],
        requiresAuth: true,
        permission: "show_qr_code",
      },
    },


    {
      path: "/evacuation_diagram",
      name: "EvacuationDiagram",
      component: () => import("@/views/evacuation_diagram/EvacuationDiagram.vue"),
      meta: {
        pageTitle: "Evacuation Diagram",
        breadcrumb: [
          {
            text: "Evacuation Diagram",
            active: true,
          },
        ],
        requiresAuth: true,
        permission: "show_evacuation_diagram",
      },
    },

    {
      path: "/flood_diagram",
      name: "FloodDiagram",
      component: () => import("@/views/flood_diagram/FloodDiagram.vue"),
      meta: {
        pageTitle: "Flood Diagram",
        breadcrumb: [
          {
            text: "Flood Diagram",
            active: true,
          },
        ],
        requiresAuth: true,
        permission: "show_flood_diagram",
      },
    },

    {
      path: "/flood_emergency",
      name: "FloodEmergency",
      component: () => import("@/views/flood_emergency/FloodEmergency.vue"),
      meta: {
        pageTitle: "Flood Emergency",
        breadcrumb: [
          {
            text: "Flood Emergency",
            active: true,
          },
        ],
        requiresAuth: true,
        permission: "show_flood_emergency",
      },
    },

    {
      path: "/ecl",
      name: "Ecl",
      component: () => import("@/views/ecl/Ecl.vue"),
      meta: {
        pageTitle: "Emergency Contact List",
        breadcrumb: [
          {
            text: "Emergency Contact List",
            active: true,
          },
        ],
        requiresAuth: true,
        permission: "show_emergency_contact_list",
      },
    },

    {
      path: "/assembly_area",
      name: "AssemblyArea",
      component: () => import("@/views/assembly_area/AssemblyArea.vue"),
      meta: {
        pageTitle: "Assembly Area",
        breadcrumb: [
          {
            text: "Assembly Area",
            active: true,
          },
        ],
        requiresAuth: true,
        permission: "show_assembly_area",
      },
    },


    {
      path: "/emergency_scenario_drill",
      name: "EmergencyScenarioDrill",
      component: () => import("@/views/emergency_scenario_drill/EmergencyScenarioDrill.vue"),
      meta: {
        pageTitle: "Emergency Scenario Drill",
        breadcrumb: [
          {
            text: "Emergency Scenario Drill",
            active: true,
          },
        ],
        requiresAuth: true,
        permission: "show_emergency_scenario_drill",
      },
    },

    {
      path: "/equipment_report",
      name: "EquipmentReport",
      component: () => import("@/views/equipment_report/EquipmentReport.vue"),
      meta: {
        pageTitle: "Equipment Report",
        breadcrumb: [
          {
            text: "Equipment Report",
            active: true,
          },
        ],
        requiresAuth: true,
        permission: "show_equipment_report",
      },
    },

    {
      path: "/device",
      name: "Device",
      component: () => import("@/views/device/Device.vue"),
      meta: {
        pageTitle: "Device",
        breadcrumb: [
          {
            text: "Device",
            active: true,
          },
        ],
        requiresAuth: true,
        permission: "show_device",
      },
    },

    {
      path: "/fire_alarm",
      name: "FireAlarm",
      component: () => import("@/views/fire_alarm/FireAlarm.vue"),
      meta: {
        pageTitle: "Fire Alarm",
        breadcrumb: [
          {
            text: "Fire Alarm",
            active: true,
          },
        ],
        requiresAuth: true,
        permission: "show_fire_alarm",
      },
    },

    {
      path: "/approval_module",
      name: "FlatUsers",
      component: () => import("@/views/flat_user/FlatUser.vue"),
      meta: {
        pageTitle: "Approval Module",
        breadcrumb: [
          {
            text: "Approval Module",
            active: true,
          },
        ],
        requiresAuth: true,
        permission: "show_fire_alarm",
      },
    },

    {
      path: "/subscription",
      name: "Subscription",
      component: () => import("@/views/subscription/Subscription.vue"),
      meta: {
        pageTitle: "Email Subscription",
        breadcrumb: [
          {
            text: "Email Subscription",
            active: true,
          },
        ],
        requiresAuth: true,
        permission: "show_subscription",
      },
    },

    {
      path: "/peeps",
      name: "Peep",
      component: () => import("@/views/peep/Peep.vue"),
      meta: {
        pageTitle: "PEEPs",
        breadcrumb: [
          {
            text: "PEEPs",
            active: true,
          },
        ],
        requiresAuth: true,
        permission: "show_peep",
      },
    },

    {
      path: "/building_emergency_state",
      name: "BuildingEmergencyState",
      component: () => import("@/views/building_emergency/BuildingEmergency.vue"),
      meta: {
        pageTitle: "Building Activity Log",
        breadcrumb: [
          {
            text: "Building Activity Log",
            active: true,
          },
        ],
        requiresAuth: true,
        permission: "show_user_building",
      },
    },

    {
      path: "*",
      redirect: "/login",
    },
  ],
});

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

export default router;
